export const getters = {
  isLoading: state => state.isLoading,
  loadingCount: state => state.loadingCount
}

export default getters



// WEBPACK FOOTER //
// ./src/store/module/common/getters.js